/**
 * Turn any axios error / FastAPI response body into a plain string suitable
 * for `toast.error(...)`. Handles:
 *   - `detail: "string"`        → the string
 *   - `detail: [{msg, loc, ...}, ...]` (Pydantic 422) → joined "loc: msg"
 *   - `detail: {code, message}`   (our own shape) → the message
 *   - anything else               → the fallback
 *
 * This exists because passing a raw Pydantic error array to sonner's
 * `toast.error` causes React to try to render the object as JSX and crash
 * with "Objects are not valid as a React child".
 */
export function errMsg(err, fallback = 'Something went wrong') {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) {
    return d
      .map((e) => {
        if (typeof e === 'string') return e;
        const loc = Array.isArray(e?.loc) ? e.loc.slice(-1)[0] : e?.loc;
        return loc ? `${loc}: ${e?.msg || ''}` : (e?.msg || JSON.stringify(e));
      })
      .join('; ');
  }
  if (d && typeof d === 'object') {
    return d.message || d.msg || d.detail || JSON.stringify(d);
  }
  const msg = err?.message;
  return (typeof msg === 'string' && msg) ? msg : fallback;
}
